import { TransformedCmAccordion } from '~/transforms/transformModules';
import { FAQPage, WithContext } from 'schema-dts';

/**
 * Generates FAQPage JSON-LD schema from TransformedCmAccordion
 * @param faqData TransformedCmAccordion object
 * @returns FAQPage schema object
 */
export function generateFAQSchema(faqData: TransformedCmAccordion['data']): WithContext<FAQPage> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity:
      faqData.collapsibles?.map(item => ({
        '@type': 'Question',
        name: item.headline || '',
        acceptedAnswer: {
          '@type': 'Answer',
          text: typeof item.content === 'string' ? item.content : '',
        },
      })) || [],
  };
}
